import { useCompetitionResultListQuery } from '~/pages/competition/result/manage/queries';
import { RecordResultsListFilter } from './components/record-results-list-filter';
import { SimpleCompetitionTypeToIdMap } from '../../list/components/query-schema';
import { RecordResultsListTable } from './components/record-results-list-table';
import { Pagination } from '~/components/Pagination/Pagination';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Fragment } from 'react/jsx-runtime';
import { querySchema } from './query-schema';
import { toIsMaleFilter } from '~/utils/sex';

export const Page = withPrivateRoute(() => {
  const { values } = useFilterForm(querySchema.parse);

  const { data, isLoading } = useCompetitionResultListQuery({
    person: values.person ? Number(values.person) : undefined,
    competition_type: SimpleCompetitionTypeToIdMap[values.competition_type],
    age_category: values.age_category_id,
    is_male: toIsMaleFilter(values.sex),
    only_can_modify_record: true,
    end_date: values.to_date,
    start_date: values.from_date,
    weight_class: values.weight_class_id,
    page_size: values.pageSize,
    page: values.pageIndex,
  });

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Hantera rekord" />
      </PageLayout.Header>

      <PageLayout.Section>
        <RecordResultsListFilter />
        <RecordResultsListTable results={data?.results ?? []} isLoading={isLoading} />
        <Pagination count={data?.count} />
      </PageLayout.Section>
    </Fragment>
  );
});
